import {PlatformedQueryFilters} from "../..";
import {nominate} from "platformed-client/types";

export * from "./account";
export * from "./trustCenter";
export * as portal from "./portal";
export * as portalDiscovery from "./portalDiscovery";
export * as auth from "./auth";

export function filter(): PlatformedQueryFilters {
  return nominate("platformedQueryFilters", {queryKey: ["external"]});
}
